<template>
  <div class="w-full h-full mt-20">
    <div v-if="!workflow" class="text-lg mb-4">
      {{ $t("Loading...") }}
    </div>
    <v-ace-editor v-model:value="workflow" lang="yaml" theme="chrome" style="height: 400px; font-size: 18px" />
  </div>
</template>

<script>
import { VAceEditor } from "vue3-ace-editor"
import "ace-builds/src-noconflict/mode-yaml"
import "ace-builds/src-noconflict/theme-chrome"

export default {
  components: {
    VAceEditor
  },
  props: {
    playbook: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  data() {
    return {
      workflow: ""
    }
  },

  watch: {
    workflow() {
      this.$emit("change", this.workflow)
    }
  },
  created() {
    setTimeout(() => {
      this.workflow = this.playbook.flowchart
    }, 2000)
  },
  methods: {
    // async savePlaybook() {
    //   this.workflow = this.editor.getValue()
    //   this.$store.dispatch("playbooks/updatePlaybook", { id: this.playbook.id, data:{ flowchart: this.workflow} })
    // }
  }
}
</script>
